export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/environments/environment.ts